import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'photoOverlayStyles',
    standalone: false
})
export class PhotoOverlayStylesPipe implements PipeTransform {
  transform(
    hasColorOverlay: any,
    colorOverlay: any,
    imageUrl: any,
    scale: number = 1,
  ): Record<string, any> {
    const styles: Record<string, string> = {};

    if (hasColorOverlay && colorOverlay && imageUrl) {
      styles.backgroundColor = colorOverlay;
      // @ts-ignore
      styles.mask = `url(${imageUrl.changingThisBreaksApplicationSecurity}) center / contain no-repeat`;
    }

    styles.transform = `scale(${scale})`;

    return styles;
  }
}
